import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The Environment a viewport pass tonemaps its 3D render with. Godot's tonemap pass reads the
 * environment its render forces: the camera's, else that of the scenario the viewport renders
 * (`renderer_scene_cull.cpp:3594-3613`), the world `find_world_3d()` resolves
 * (`viewport.cpp:4670-4681`). `ViewportPassEnvironment` provides it, and each viewport's tonemap
 * pass reads it (`toneMapPass.ts`).
 */
import { createContext, useContext, useMemo } from 'react';
import { useAutoExposure } from './worldExposure';
const PassToneMapContext = createContext({
    settings: null,
    glowMap: null,
});
PassToneMapContext.displayName = 'PassToneMapContext';
/** Gives the tonemap stage below it the Environment its pass draws with. One per viewport pass. */
export function PassToneMapProvider({ settings, glowMap, children, }) {
    const value = useMemo(() => ({ settings, glowMap }), [settings, glowMap]);
    return _jsx(PassToneMapContext.Provider, { value: value, children: children });
}
/**
 * What the tonemap of this viewport pass reads: its Environment and its auto exposure.
 *
 * @canonical The Environment a viewport tonemaps with
 */
export function usePassToneMap() {
    const environment = useContext(PassToneMapContext);
    const autoExposure = useAutoExposure();
    return useMemo(() => ({ ...environment, autoExposure }), [environment, autoExposure]);
}
//# sourceMappingURL=passToneMap.js.map